import Component from './campaign_add_edit_dialog.vue'
export default Component
